import { useEffect } from 'react';

import { NotificationType, useNotificationContext } from 'core/context/Notifications';

export interface ErrorMutationProps {
  type: NotificationType;
  title: string;
  message: string;
  duration?: number;
}

/**
 * @deprecated You should dispatch the notification programmatically with useNotificationContext instead
 */
const ErrorMutation = ({ type, title, message, duration = 5 }: ErrorMutationProps) => {
  const { dispatch } = useNotificationContext();

  useEffect(() => {
    dispatch(type, title, message, duration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ErrorMutation;
